import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (param) {
    return store.dispatch('checkResponseApi', await Api().get('users' + param))
  },

  async getLogs (data) {
    return store.dispatch('checkResponseApi', await Api().get('user/logs?user_id=' + data.user_id))
  },

}



// WEBPACK FOOTER //
// ./src/api/UserService.js